import { render } from "./NewOldJournalByYear.vue?vue&type=template&id=2d76cbd5&scoped=true"
import script from "./NewOldJournalByYear.vue?vue&type=script&lang=js"
export * from "./NewOldJournalByYear.vue?vue&type=script&lang=js"

import "./NewOldJournalByYear.vue?vue&type=style&index=0&id=2d76cbd5&scoped=true&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d76cbd5"]])

export default __exports__